







































































































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import MiniStatistic from "@/components/MiniStatistic.vue";
import {Options} from "highcharts";
import {Chart} from "highcharts-vue";
import Axios from "axios";
import Moment from "moment";

@Component({
	components: {MiniStatistic, HighCharts: Chart}
})
export default class Home extends Vue {
	@Prop({required: true})
	countries: any;

	cacheCountries: any = [];
	loading: boolean = false;

	search: string = null;
	select: string = null;

	countryFlag: string = '';

	tab: any = null
	tabItems: any = ['Cases', 'Deaths', 'Patients', 'Tests']

	@Watch('search')
	selectCountry(country: string) {
		country && country !== this.select && this.countrySelections(country)
	}

	countrySelections(v: any) {
		this.loading = true;
		setTimeout(() => {
			this.cacheCountries = this.countries.filter((e: any) => {
				return (e.name || '').toLowerCase().indexOf((v || '').toLowerCase()) > -1
			})
			this.loading = false
		}, 500)
	}

	timeConverter(time: number) {
		const fullDate = new Date(time);
		return Moment(fullDate).format("hh:mm:ss A - ddd MMMDD,YY")
	}

	coronaCountries: any[] = [];

	chartTodayOptions: Options = {}
	chartTotalOptions: Options = {}

	created() {
		this.dataLoad()
	}

	dataLoad() {
		this.getFromApi().then(() => {
			let val: any = {}
			val = this.coronaCountries

			let todaySeries = [{
				name: 'Cases',
				data: [val.todayCases]
			}, {
				name: 'Critical',
				data: [val.critical]
			}, {
				name: 'Recovered',
				data: [val.todayRecovered]
			}, {
				name: 'Deaths',
				data: [val.todayDeaths]
			}]

			let totalSeries = [{
				name: 'Cases',
				data: [val.cases]
			}, {
				name: 'Active',
				data: [val.active]
			}, {
				name: 'Recovered',
				data: [val.recovered]
			}, {
				name: 'Deaths',
				data: [val.deaths]
			}]

			this.chartTodayOptions = {
				colors: ['#DDDF00', '#ff001e', '#50B432', '#ED561B'],
				chart: {
					zoomType: 'x',
					type: 'column',
					backgroundColor: 'transparent'
				},
				title: {
					text: null
				},
				xAxis: {
					categories: ['Today']
				},
				yAxis: {
					title: {
						text: 'In Number'
					}
				},
				legend: {
					verticalAlign: 'top',
					enabled: true
				},
				plotOptions: {
					area: {
						marker: {
							radius: 2
						},
						lineWidth: 1,
						states: {
							hover: {
								lineWidth: 1
							}
						},
						threshold: null
					}
				},
				//@ts-ignore
				series: todaySeries
			}

			this.chartTotalOptions = {
				colors: ['#fae607', '#a36868', '#6407fa', '#fa0707'],
				chart: {
					zoomType: 'x',
					type: 'column',
					backgroundColor: 'transparent'
				},
				title: {
					text: null
				},
				xAxis: {
					categories: ['Total']
				},
				yAxis: {
					title: {
						text: 'In Number'
					}
				},
				legend: {
					verticalAlign: 'top',
					enabled: true
				},
				plotOptions: {
					area: {
						marker: {
							radius: 2
						},
						lineWidth: 1,
						states: {
							hover: {
								lineWidth: 1
							}
						},
						threshold: null
					}
				},
				//@ts-ignore
				series: totalSeries
			}
		})
	}

	getFromApi() {
		this.coronaCountries = [];
		if (!this.select) {
			return Axios.get("https://corona.lmao.ninja/v2/all")
				  .then(({data}) => {
					  this.coronaCountries = data
				  }).finally(() => {
					  this.countryFlag = 'fa fa-globe text--secondary';
				  })
		} else {
			return Axios.get("https://corona.lmao.ninja/v2/countries/" + this.select)
				  .then(({data}) => {
					  this.coronaCountries = JSON.parse(JSON.stringify(data))
				  })
				  .catch(error => {
					  this.$notify({
						  type: 'error',
						  title: "Country's info not found!!"
					  });
				  }).finally(() => {
					  let ifAvailable = this.countries.find((e: any) => e.name === this.select);
					  if (ifAvailable)
						  this.countryFlag = 'flag-icon flag-icon-' + ifAvailable.code.toLowerCase();
				  })
		}
	}
}
